// Generate IEEE standard citation format

function getIEEEEdition(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'edition') ? `(${tags.edition.join(', ')})` : '';
}
function getIEEEAuthors(tags) {
    if (!Object.prototype.hasOwnProperty.call(tags, 'author')) {
        return '';
    }
    const authors = [];
    $.each(tags.author, (index, value) => {
        value = ieeeFormatName(value);
        authors.push(value);
    });
    return authors.join(', ');
}
function getIEEECountry(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'country') ? `${tags.country.join(', ')}: ` : '';
}
function getIEEEPublisher(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'publisher') ? tags.publisher.join(', ') : '';
}
function getIEEEPublicationDate(issue) {
    return Object.prototype.hasOwnProperty.call(issue, 'publication_date') ? `${issue.publication_date}` : '';
}
function getIEEETitle(issue, title) {
    return Object.prototype.hasOwnProperty.call(issue, 'title') && issue.title.length ? issue.title : title;
}
function getIEEEIssueUrl(issue, currentLocation, isEpub = false, localizations) {
    const location = isEpub ? btoa(JSON.stringify(currentLocation)) : currentLocation;
    return Object.prototype.hasOwnProperty.call(issue, 'issue_url') > 0
        ? `${localizations.citation.messages.availableIn}: ${issue.issue_url}?location=${location}`
        : '';
}
function ieeeFormatName(name) {
    return name;
}

function formatValue(string, punctuation = null) {
    punctuation = punctuation ? punctuation : '.';
    const trimmedString = string.trim();
    if (!trimmedString) {
        return '';
    }
    return trimmedString.endsWith(punctuation) ? `${trimmedString} ` : `${trimmedString}${punctuation} `;
}

const IEEECitation = (text, issue, currentLocation, issueTitle, isEpub, localizations) => {
    const author = getIEEEAuthors(issue.tags);
    const date = getIEEEPublicationDate(issue);
    const title = getIEEETitle(issue, issueTitle);
    const _edition = getIEEEEdition(issue.tags);
    const country = getIEEECountry(issue.tags);
    const publisher = getIEEEPublisher(issue.tags);
    const url = getIEEEIssueUrl(issue, currentLocation, isEpub, localizations);

    const citation = `${formatValue(author, ',')}${formatValue(title)}${formatValue(country, ':')}${formatValue(publisher, ',')}${formatValue(
        date
    )}[${localizations.citation.messages.online}] ${url}`;

    if (text && text.trim()) {
        return `"${text}"

${citation}`;
    }

    return citation;
};

export default IEEECitation;
